import React from 'react'
import { useTranslation } from 'react-i18next'
import { ImageIcon } from '@node-space/storybook-components/dist/ImageIcon'
import { TextAction } from '@node-space/storybook-components/dist/TextAction'
import { Box as Body, Box, Box as Container, Box as Page, Text } from '@node-space/ui-components'
import { LogoHeader } from 'components/header/LogoHeader'
import { Description } from 'components/Text'
import { ExternalLinks } from 'constants/ExternalLinks'

const NotAvailable = () => {
  const { t } = useTranslation()

  return (
    <Page flexCol width="full" minHeight="screen">
      <Box paddingB={20}>
        <LogoHeader />
      </Box>
      <Container flex align="center" flexSize="fill" padding={32} className="bg-gray-03">
        <Body>
          <ImageIcon
            width={237}
            height={248}
            src="assets/infographics/world-rotate-animation.svg"
          />
          <Box flexCol gap={12} paddingT={4} className="max-w-xl">
            <Text tag="h1" variant="heading-1">
              {t('notAvailable.heading')}
            </Text>
            <Description>
              {t('notAvailable.description')}{' '}
              <TextAction
                text={t('contactSupportLowercase')}
                linkTo={ExternalLinks.contactSupport}
              />
              .
            </Description>
          </Box>
        </Body>
      </Container>
    </Page>
  )
}

export default NotAvailable
